const default_flow = {
  construction: {
    actionDatas: {
      swapToUsdc: {
        action: {
          actionTypeUID: "MALLOC_SPL_RAYDIUM_SWAP",
          actionPID: "muZ8k7AinSTHUwyDU34FL9Ebfy2SdAPHFbMLpnUC6yM",
          inputs: {
            outMint: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
          },
          nextActions: [{ lpDepositUsdcRay: 1 }],
        },
      },
      lpDepositUsdcRay: {
        action: {
          actionPID: "muZ8k7AinSTHUwyDU34FL9Ebfy2SdAPHFbMLpnUC6yM",
          actionTypeUID: "MALLOC_SPL_RAYDIUM_LP_DEPOSIT",
          inputs: {},
          nextActions: [{ farmUsdcRay: 1 }],
        },
      },
      farmUsdcRay: {
        action: {
          actionPID: "muZ8k7AinSTHUwyDU34FL9Ebfy2SdAPHFbMLpnUC6yM",
          actionTypeUID: "MALLOC_SPL_RAYDIUM_LP_STAKE_FARM",
          inputs: {},
          nextActions: [],
        },
      },
      swapToRay: {
        action: {
          actionTypeUID: "MALLOC_SPL_RAYDIUM_SWAP",
          actionPID: "muZ8k7AinSTHUwyDU34FL9Ebfy2SdAPHFbMLpnUC6yM",
          inputs: {
            outMint: "4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R",
          },
          nextActions: [{ lpDepositSolRay: 1, lpDepositUsdcRay: 1 }],
        },
      },
      lpDepositSolRay: {
        action: {
          actionPID: "muZ8k7AinSTHUwyDU34FL9Ebfy2SdAPHFbMLpnUC6yM",
          actionTypeUID: "MALLOC_SPL_RAYDIUM_LP_DEPOSIT",
          inputs: { hasFarm: true },
          nextActions: [{ farmSolRay: 1 }],
        },
      },
      farmSolRay: {
        action: {
          actionPID: "muZ8k7AinSTHUwyDU34FL9Ebfy2SdAPHFbMLpnUC6yM",
          actionTypeUID: "MALLOC_SPL_RAYDIUM_LP_STAKE_FARM",
          inputs: {},
          nextActions: [],
        },
      },
    },
    source: {
      nextActions: {
        swapToRay: 100,
        lpDepositSolRay: 100,
        swapToUsdc: 100,
      },
      mints: { So11111111111111111111111111111111111111112: "2000" },
    },
  },
  savedContext: {
    nodes: {
      SOURCE: [-183.15625, -19],
      swapToRay: [-60.15625, -37],
      lpDepositSolRay: [-47.15625, -168],
      swapToUsdc: [-52.15625, 79],
      lpDepositUsdcRay: [50.84375, 10.984375],
      farmUsdcRay: [203.84375, 14],
      farmSolRay: [87.84375, -172],
    },
    translate: [316.5, 250],
    scale: 1,
  },
};

export default default_flow;
